<template>
  <div>
    <div class="" v-show="insideLandsHeaderIsVisible">
      <header class="layout-header">
        <!-- message bar -->
        <div
          class="db fixed w-100 message-bar flex flex-column justify-center items-center tc bg-navy z-header"
          :class="{ 'is-hidden': messageBarIsClicked || scrolled || menuIconIsClicked }"
          style="z-index: 99999"
        >
          <message-bar-content :key="$route.fullPath"></message-bar-content>
          <a
            class="db absolute right-0 mr2 nt1 f2 lh-solid is-cream pointer"
            @click="
              messageBarIsClicked = !messageBarIsClicked;
              messageBarClosedMethod();
            "
            >&times;</a
          >
        </div>
        <!-- header fixed -->
        <!-- Mobile  -->
        <div
          class="db dn-ns fixed top-0 w-100 z-header"
          :class="{ 'is-scrolled': fixedHeaderIsVisible }"
        >
          <div
            class="db relative w-100 h2 message-bar-spacer bg-beige"
            :class="{ 'is-hidden': messageBarIsClicked || scrolled || menuIconIsClicked }"
          ></div>
          <div
            class="il-header flex flex-row items-center"
            :class="{ 'bg-navy': menuIconIsClicked }"
          >
            <div class="flex w-100 ph2 mh2 bg-beige">
              <div class="tl">
                <router-link
                  class="flex relative tc w5 il-header-cta has-red-bg mt1 overflow-hidden ttn pointer"
                  to="/tickets/"
                  v-on:click.native="closeNav()"
                  title="Buy 2021 Tickets"
                  :id="navigation.header_cta_button.id"
                >
                  <span class="text pointer is-lorano-bold"> Buy 2021 Tickets </span>
                </router-link>
              </div>
              <div class="tc w-100">
                <div class="flex w-100 mw5 flex-row items-center justify-around">
                  <span
                    v-for="(item, index) in navItems"
                    :key="'il-nav-item-' + item.title"
                    v-if="index > 0"
                  >
                    <a
                      v-if="item.is_link_out === true"
                      class="flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary"
                      :href="item.link"
                      :title="item.title"
                      :id="'il-nav-item-' + item.title"
                      target="_blank"
                    >
                      <span class="text f3">
                        {{ item.title }}
                      </span>
                    </a>
                    <router-link
                      v-else
                      class="flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary"
                      :to="item.link"
                      :title="item.title"
                      :id="'il-nav-item-' + item.title"
                    >
                      <span class="text f3">
                        {{ item.title }}
                      </span>
                    </router-link>
                  </span>
                </div>
              </div>
              <div class="tr w-auto flex flex-row items-center">
                <transition name="slide-fade-logo">
                  <router-link
                    class="dib is-white w-100 mr0 is-black"
                    v-if="fixedHeaderIsVisible || menuIconIsClicked"
                    to="/"
                    v-on:click.native="closeNav()"
                    title="Outside Lands"
                  >
                    <svg
                      height="25.444"
                      viewBox="0 0 36.486 25.444"
                      width="36.486"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="#200013">
                        <path
                          d="m-22.689 0h-11.44a3.032 3.032 0 0 0 -3.032 3.032v19.38a3.032 3.032 0 0 0 3.032 3.032h11.44a3.032 3.032 0 0 0 3.032-3.032v-19.38a3.032 3.032 0 0 0 -3.032-3.032m-4.627 18.462h-2.184a.466.466 0 0 1 -.468-.462v-10.581a.466.466 0 0 1 .466-.466h2.186a.466.466 0 0 1 .466.466v10.581a.466.466 0 0 1 -.466.466"
                          transform="translate(37.161)"
                        />
                        <path
                          d="m-44.2-28.563h-10.1v-17.837a.385.385 0 0 0 -.385-.385h-6.422a.385.385 0 0 0 -.385.385v24.641a.385.385 0 0 0 .385.385h17.246a.385.385 0 0 0 .386-.385v-6.422a.385.385 0 0 0 -.386-.386"
                          transform="translate(79.966 46.794)"
                        />
                      </g>
                    </svg>
                  </router-link>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <div
          class="dn db-ns fixed top-0 w-100 z-header il-header-desktop"
          :class="{ 'is-scrolled': fixedHeaderIsVisible }"
        >
          <div
            class="db relative w-100 message-bar-spacer bg-beige"
            :class="{ 'is-hidden': messageBarIsClicked || scrolled || menuIconIsClicked }"
          ></div>
          <div class="il-header-dt">
            <div class="il-header-dt-inner">
              <div class="relative flex flex-row items-center w-100 h-100">
                <div
                  class="relative w-100 flex flex-row items-center justify-between il-header-desktop-nav-mw"
                >
                  <router-link
                    class="flex relative tc w5 il-header-cta has-red-bg overflow-hidden ttn pointer"
                    to="/tickets/"
                    v-on:click.native="closeNav()"
                    title="Buy 2021 Tickets"
                    :id="navigation.header_cta_button.id"
                  >
                    <span class="text pointer is-lorano-bold"> Buy 2021 Tickets </span>
                  </router-link>
                  <span
                    v-for="(item, index) in navItems"
                    :key="'il-nav-item-' + item.title"
                  >
                    <a
                      v-if="item.is_link_out === true"
                      class="flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary"
                      :href="item.link"
                      :title="item.title"
                      :id="'il-nav-item-' + item.title"
                      target="_blank"
                    >
                      <span class="text f3">
                        {{ item.title }}
                      </span>
                    </a>
                    <router-link
                      v-else
                      class="flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary"
                      :to="item.link"
                      :title="item.title"
                      :id="'il-nav-item-' + item.title"
                    >
                      <span class="text f3">
                        {{ item.title }}
                      </span>
                    </router-link>
                  </span>
                </div>
                <div class="dn db-ns tr absolute right-2">
                  <transition name="slide-fade-logo">
                    <div
                      v-if="fixedHeaderIsVisible"
                      class="flex flex-row items-center ttu f4 is-blue"
                    >
                      <router-link
                        class="dib w-100 mw24rem mt1 no-active-link"
                        to="/"
                        v-on:click.native="closeNav()"
                        title="Outside Lands"
                      >
                        <simple-svg
                          class="icon"
                          id="ol19-header-scroll-logo"
                          filepath="/assets/images/svg/ol21-lockup-header-scroll-new-dates.svg"
                        ></simple-svg>
                      </router-link>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    <header class="layout-header" v-show="!insideLandsHeaderIsVisible">
      <!-- message bar -->
      <div
        class="db fixed w-100 message-bar flex flex-column justify-center items-center tc bg-navy z-header"
        :class="{ 'is-hidden': messageBarIsClicked || scrolled || menuIconIsClicked }"
        style="z-index: 99999"
      >
        <message-bar-content :key="$route.fullPath"></message-bar-content>
        <a
          class="db absolute right-0 mr2 nt1 f2 lh-solid is-cream pointer"
          @click="
            messageBarIsClicked = !messageBarIsClicked;
            messageBarClosedMethod();
          "
        >
          &times;
        </a>
      </div>
      <!-- header fixed -->
      <div
        class="db dn-ns fixed top-0 w-100 z-header"
        :class="{ 'is-scrolled': fixedHeaderIsVisible }"
      >
        <div
          class="db relative w-100 h2 message-bar-spacer bg-beige"
          :class="{ 'is-hidden': messageBarIsClicked || scrolled || menuIconIsClicked }"
        ></div>
        <div
          class="header flex flex-row items-center"
          :class="{ 'bg-navy': menuIconIsClicked }"
        >
          <div class="header-inner w-100 ph2">
            <div class="tl">
              <!-- <a class="flex relative tc w5 header-cta has-orange-bg overflow-hidden f4 f3-ns ttn pointer link" @click="closeNav(); openModalComponent();" :title="navigation.header_cta_button.title" :id="navigation.header_cta_button.id">
                <span class="text is-lorano-bold">
                  {{ navigation.header_cta_button.title }}
                </span>
              </a> -->
              <router-link
                class="flex relative tc w5 header-cta has-red-bg overflow-hidden f4 f3-ns ttn pointer link"
                :to="navigation.header_cta_button.link"
                v-on:click.native="closeNav();"
                :title="navigation.header_cta_button.title"
                :id="navigation.header_cta_button.id"
              >
                <span class="text is-lorano-bold">
                  {{ navigation.header_cta_button.title }}
                </span>
              </router-link>
            </div>
            <div class="tc w-100"></div>
            <div class="tr w-auto flex flex-row items-center">
              <transition name="slide-fade-logo">
                <router-link
                  class="dib is-white w-100 mr3 is-black"
                  v-if="fixedHeaderIsVisible || menuIconIsClicked"
                  to="/"
                  v-on:click.native="closeNav()"
                  title="Outside Lands"
                >
                  <svg
                    height="25.444"
                    viewBox="0 0 36.486 25.444"
                    width="36.486"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="#200013">
                      <path
                        d="m-22.689 0h-11.44a3.032 3.032 0 0 0 -3.032 3.032v19.38a3.032 3.032 0 0 0 3.032 3.032h11.44a3.032 3.032 0 0 0 3.032-3.032v-19.38a3.032 3.032 0 0 0 -3.032-3.032m-4.627 18.462h-2.184a.466.466 0 0 1 -.468-.462v-10.581a.466.466 0 0 1 .466-.466h2.186a.466.466 0 0 1 .466.466v10.581a.466.466 0 0 1 -.466.466"
                        transform="translate(37.161)"
                      />
                      <path
                        d="m-44.2-28.563h-10.1v-17.837a.385.385 0 0 0 -.385-.385h-6.422a.385.385 0 0 0 -.385.385v24.641a.385.385 0 0 0 .385.385h17.246a.385.385 0 0 0 .386-.385v-6.422a.385.385 0 0 0 -.386-.386"
                        transform="translate(79.966 46.794)"
                      />
                    </g>
                  </svg>
                </router-link>
              </transition>
              <a
                class="dib relative nav-toggle pointer"
                :class="{ 'is-clicked': menuIconIsClicked }"
                @click="menuIconIsClicked = !menuIconIsClicked"
              >
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="dn db-ns fixed top-0 w-100 z-header header-desktop"
        :class="{ 'is-scrolled': fixedHeaderIsVisible }"
      >
        <div
          class="db relative w-100 h2 message-bar-spacer bg-beige"
          :class="{ 'is-hidden': messageBarIsClicked || scrolled || menuIconIsClicked }"
        ></div>
        <div class="relative flex flex-row items-center ph2-m ph4-l w-100 h-100 header">
          <div
            class="relative w-100 flex flex-row items-center justify-between header-desktop-nav-mw"
          >
            <router-link
              class="flex relative tc w5 header-cta has-red-bg overflow-hidden f3 ttn is-white pointer"
              :to="navigation.header_cta_button.link"
              v-on:click.native="closeNav()"
              :title="navigation.header_cta_button.title"
              :id="navigation.header_cta_button.id"
            >
              <span class="text">
                {{ navigation.header_cta_button.title }}
              </span>
            </router-link>
            <!--
            <a class="flex relative tc w5 header-cta has-red-bg overflow-hidden f3 ttn is-white pointer" @click="closeNav(); openModalComponent();" :title="navigation.header_cta_button.title" :id="navigation.header_cta_button.id">
              <span class="text">
                {{ navigation.header_cta_button.title }}
              </span>
            </a>
            -->
            <router-link
              v-for="item in navigation.navigation_items"
              v-if="item.is_cta != true && item.is_link_out != true"
              class="flex relative tc no-underline pointer is-tablet-cond-bold is-black nav-link-primary"
              :to="item.link"
              :key="item.title"
              :title="item.title"
              :id="item.id"
            >
              <span v-if="item.text_html" v-html="item.text_html"> </span>
              <span v-else-if="item.is_primary" class="text f3">
                {{ item.title }}
              </span>
              <span v-else class="text f4">
                {{ item.title }}
              </span>
            </router-link>
            <a
              v-else-if="item.is_link_out"
              class="flex relative tc is-tablet-cond-bold is-black no-underline pointer nav-link-primary"
              :href="item.link"
              target="_blank"
              :title="item.title"
              :id="item.id"
            >
              <span class="text f4">
                {{ item.title }}
              </span>
            </a>
            <router-link
              v-else
              class="flex relative tc is-white no-underline pointer nav-link-search"
              to="/search/"
              :title="item.title"
            >
              <span
                v-if="item.text_html"
                v-html="item.text_html"
                v-show="!searchBarIconIsClicked"
              ></span>
              <!--<a class="f1 nt2 is-black search-close pointer" @click="searchBarIconIsClicked = !searchBarIconIsClicked" v-show="searchBarIconIsClicked" :class="{ 'is-clicked': searchBarIconIsClicked }">&times;</a>-->
            </router-link>
          </div>
          <div class="dn db-l-header-logo tr absolute right-2">
            <transition name="slide-fade-logo">
              <router-link
                class="dib w-100 mr3 is-navy-fill no-active-link"
                v-if="fixedHeaderIsVisible || menuIconIsClicked"
                to="/"
                v-on:click.native="closeNav()"
                title="Outside Lands 2019"
              >
                <svg
                  height="25.444"
                  viewBox="0 0 36.486 25.444"
                  width="36.486"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      d="m-22.689 0h-11.44a3.032 3.032 0 0 0 -3.032 3.032v19.38a3.032 3.032 0 0 0 3.032 3.032h11.44a3.032 3.032 0 0 0 3.032-3.032v-19.38a3.032 3.032 0 0 0 -3.032-3.032m-4.627 18.462h-2.184a.466.466 0 0 1 -.468-.462v-10.581a.466.466 0 0 1 .466-.466h2.186a.466.466 0 0 1 .466.466v10.581a.466.466 0 0 1 -.466.466"
                      transform="translate(37.161)"
                    />
                    <path
                      d="m-44.2-28.563h-10.1v-17.837a.385.385 0 0 0 -.385-.385h-6.422a.385.385 0 0 0 -.385.385v24.641a.385.385 0 0 0 .385.385h17.246a.385.385 0 0 0 .386-.385v-6.422a.385.385 0 0 0 -.386-.386"
                      transform="translate(79.966 46.794)"
                    />
                  </g>
                </svg>
              </router-link>
            </transition>
          </div>
          <div class="dn db-xl-header-logo tr absolute right-2">
            <transition name="slide-fade-logo">
              <div
                v-if="fixedHeaderIsVisible"
                class="flex flex-row items-center ttu f4 is-blue"
              >
                <router-link
                  class="dib w-100 mw24rem mt1 no-active-link"
                  to="/"
                  v-on:click.native="closeNav()"
                  title="Outside Lands"
                >
                  <simple-svg
                    class="icon"
                    id="ol19-header-scroll-logo"
                    filepath="/assets/images/svg/ol21-lockup-header-scroll-new-dates.svg"
                  ></simple-svg>
                </router-link>
              </div>
            </transition>
          </div>
        </div>
        <page-sub-nav></page-sub-nav>
      </div>
      <transition name="menu-transition">
        <div class="db dn-ns menu menu-transition z-menu" v-show="menuIconIsClicked">
          <transition name="nav-transition">
            <div class="layout-header-sidebar bg-navy" v-show="menuIconIsClicked">
              <mobile-nav></mobile-nav>
            </div>
          </transition>
        </div>
      </transition>
    </header>
    <header-spacer></header-spacer>
  </div>
</template>
<script>
import { bus } from "../../assets/js/src/main";
import HeaderSpacer from "./header-spacer.vue";
import MobileNav from "./mobile-nav.vue";
import SignupModal from "./signup-modal.vue";
import PageSubNav from "./page-sub-nav.vue";
import MessageBarContent from "./message-bar-content.vue";
//import HeaderSearchBar from './header-search-bar.vue';
export default {
  components: {
    HeaderSpacer,
    MobileNav,
    SignupModal,
    PageSubNav,
    MessageBarContent,
    //HeaderSearchBar,
  },
  data() {
    return {
      messageBarIsClicked: false,
      fixedHeaderIsVisible: false,
      fixedHeaderScrollPoint: 100,
      scrolled: false,
      menuIconIsClicked: false,
      navDesktopIsVisible: false,
      fixedHeaderLogoRightIsVisible: false,
      searchBarIconIsClicked: false,
      insideLandsHeaderIsVisible: false,
      navItems: [
        {
          title: "Home",
          link: "/insidelands",
        },
        {
          title: "Lineup",
          link: "#lineup",
        },
        {
          title: "Watch",
          link: "#watch",
        },
        {
          title: "Merch",
          link: "https://outsidelands.shop.musictoday.com/store/",
          is_link_out: true,
        },
      ],
    };
  },
  computed: {
    navigation: function () {
      var contentData = this.$store.getters.filterPagesByName("main-navigation.markdown");
      return contentData[0];
    },
    footer_content: function () {
      var footerContentData = this.$store.getters.filterPagesByName("footer.markdown");
      return footerContentData[0];
    },
    il_navigation: function () {
      var contentData = this.$store.getters.filterPagesByName(
        "inside-lands-header.markdown"
      );
      return contentData[0];
    },
  },
  methods: {
    closeNav() {
      this.menuIconIsClicked = false;
    },
    openModalComponent: function () {
      this.$modal.show(
        SignupModal,
        {
          text: "This text is passed as a property",
        },
        {
          height: "auto",
          classes: "cf-modal",
          adaptive: true,
          reset: true,
          scrollable: true,
          width: "75%",
          maxWidth: 768,
        },
        {
          "before-open": (event) => {
            console.log("1.0 - this will be called before the modal opens");
          },
        },
        {
          "before-close": (event) => {
            console.log("2.0 - this will be called before the modal closes");
          },
        }
      );
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
      if (window.scrollY > this.fixedHeaderScrollPoint) {
        this.fixedHeaderIsVisible = false;
      } else {
        this.fixedHeaderIsVisible = false;
      }
      if (this.$route.path === "/") {
        if (window.scrollY > this.fixedHeaderScrollPoint) {
          this.fixedHeaderIsVisible = true;
        } else {
          this.fixedHeaderIsVisible = false;
        }
      } else {
        this.fixedHeaderIsVisible = true;
      }
      //message bar scroll logic
      if (window.scrollY > 0) {
        //
      }
    },
    messageBarClosedMethod(data) {
      bus.$emit("messageBarClosed", data);
    },
  },
  created() {
    /****************************
      isHeaderLogoVisible check
      ****************************/
    if (this.$route.path === "/") {
      this.fixedHeaderIsVisible = false;
    } else {
      this.fixedHeaderIsVisible = true;
    }
    /****************************
      isHeaderLogoVisible check
      ****************************/
    if (this.$route.path === "/insidelands/" || this.$route.path === "/insidelands") {
      this.insideLandsHeaderIsVisible = true;
    } else {
      this.insideLandsHeaderIsVisible = false;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    /****************************
      listen for close nav event when mobile nav link is clicked
      ****************************/
    bus.$on("closeNavBus", () => {
      //this.closeNav();
      this.menuIconIsClicked = false;
    });
    bus.$on("searchBarIsSubmitBus", () => {
      this.searchBarIconIsClicked = false;
    });

    /****************************
      showSignUpModal check
      ****************************/
    //console.log('mounted - ', this.$route);
    if (this.$route.path === "/sign-up/" || this.$route.path === "/sign-up") {
      //console.log('created if - sign up: ', this.$route.path);
      this.openModalComponent();
    } else {
      //console.log('created else - sign up: ', this.$route.path);
      //this.closeModal();
      //modal.$emit('close')
    }

    this.$nextTick(() => {
      //
    });
  },
  watch: {
    $route(to, from) {
      //console.log('route change', to);
      if (to.path === "/") {
        if (window.scrollY > this.fixedHeaderScrollPoint) {
          this.fixedHeaderIsVisible = true;
        } else {
          this.fixedHeaderIsVisible = false;
        }
      } else {
        this.fixedHeaderIsVisible = true;
      }

      if (to.path === "/insidelands/" || to.path === "/insidelands") {
        this.insideLandsHeaderIsVisible = true;
      } else {
        this.insideLandsHeaderIsVisible = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    //console.log('scrolling Destroyed');
  },
  updated() {
    /****************************
      fixed Header Logo IsVisible check
      ****************************/
    if (this.$route.path === "/") {
      if (window.scrollY > this.fixedHeaderScrollPoint) {
        //console.log('vue - scrolled', window.scrollY);
        this.fixedHeaderIsVisible = true;
      } else {
        this.fixedHeaderIsVisible = false;
      }
    } else {
      this.fixedHeaderIsVisible = true;
    }
  },
};
</script>
